import React from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { apiGetCardLibraryCustomer } from '../api';
import { LoadingMask, showConfirm, showToast } from './utils';

// 库存信息里查不到该设备号时的提示文案（需求指定，勿改动措辞）
const EM_NUMBER_TIP = '设备号不正确，请检查后再次输入或通过销售渠道联系客服！';

function EmNumberInput({ onChange }: { onOk?: (v: any) => void; onChange: (v: string) => void }) {
  return (
    <div className="p-10 bw-100">
      <div className="d-flex-r h-36 mt-10 bg-gray border-radius-60 ai-center">
        <input
          className="flex-1 ml-10 mr-10 h-36"
          placeholder="请输入设备号"
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

/**
 * 登录页「在线客服」入口。
 * iccid 非空时直接带设备号进客服页（客服页按卡库客服链接 → wslCustomerUrl → 兜底链接的优先级取链接）；
 * iccid 为空时弹窗让用户输入设备号，输入的设备号在库存信息中不存在则提示后重新输入。
 */
export async function openLoginCustomer(navigate: NavigateFunction, iccid?: string) {
  const emNumber = (iccid ?? '').trim();
  if (emNumber) {
    navigate('/customer', { state: { emNumber } });
    return;
  }

  for (;;) {
    const holder = { value: '' };
    const res = await showConfirm({
      title: '输入设备号',
      content: '请输入设备号，为您接入该设备对应的客服',
      customContent: <EmNumberInput onChange={(v) => (holder.value = v)} />,
      confirmBtnText: '确定',
      cancelBtnText: '取消',
    });
    if (!res) return;

    const input = holder.value.trim();
    if (!input) {
      showToast('请输入设备号');
      continue;
    }

    let rows: any[] | null = null;
    let errMsg = '';
    LoadingMask.show();
    try {
      const r = await apiGetCardLibraryCustomer(input);
      debugger
      const data = r.data;
      if (data.code === 200) {
        rows = data.data ?? [];
      } else {
        errMsg = data.msg || '查询失败，请稍后重试';
      }
    } catch (e) {
      errMsg = '网络异常，请稍后重试';
    } finally {
      LoadingMask.hide();
    }

    if (errMsg) {
      showToast(errMsg);
      continue;
    }
    if (!rows!.length) {
      await showConfirm({
        title: '提示',
        content: EM_NUMBER_TIP,
        hideCancelBtn: true,
        confirmBtnText: '重新输入',
      });
      continue;
    }

    navigate('/customer', { state: { emNumber: input } });
    return;
  }
}
